import { render, staticRenderFns } from "./ClassicEditor.vue?vue&type=template&id=7f4098ae&"
import script from "./ClassicEditor.vue?vue&type=script&lang=js&"
export * from "./ClassicEditor.vue?vue&type=script&lang=js&"
import style0 from "./ClassicEditor.vue?vue&type=style&index=0&id=7f4098ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports